import { render, staticRenderFns } from "./PiFultiumD3.vue?vue&type=template&id=f8821e42&scoped=true&"
import script from "./PiFultiumD3.vue?vue&type=script&lang=ts&"
export * from "./PiFultiumD3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8821e42",
  null
  
)

export default component.exports